import React from 'react';

function BackArrowIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 16 12"
    >
      <path
        d="M15.4999705,5.50000428 L1.785615,5.50000428 L6.8378611,0.8681641 C7.0409861,0.6816407 7.054658,0.3652344 6.8681345,0.1621094 C6.681611,-0.0410156 6.3642282,-0.0556641 6.1620798,0.1318359 L0.1620798,5.6318359 C0.1596384,5.6339722 0.158906,5.637207 0.1567087,5.6394043 C0.1187448,5.6754761 0.0907907,5.7196655 0.0656442,5.7659912 C0.0588083,5.7787475 0.0473337,5.7885132 0.0414743,5.8018188 C0.0152292,5.8626709 -2.95e-05,5.9293823 -2.95e-05,6.00000428 C-2.95e-05,6.0706177 0.0152293,6.1373291 0.0414744,6.1981812 C0.0473338,6.2114869 0.0588084,6.2212525 0.0656443,6.2340088 C0.0907908,6.2803345 0.1187449,6.3245239 0.1567088,6.3605957 C0.158906,6.362793 0.1596384,6.3660278 0.1620798,6.3681641 L6.1620798,11.8681641 C6.2577829,11.9570312 6.3788767,12.0000043 6.4999705,12.0000043 C6.634736,12.0000043 6.7695016,11.9453125 6.8681345,11.8378906 C7.0546579,11.6347656 7.0409861,11.3183594 6.8378611,11.1318359 L1.785615,6.50000428 L15.4999705,6.50000428 C15.7763377,6.50000428 15.9999705,6.2763672 15.9999705,6.00000428 C15.9999705,5.7236328 15.7763376,5.50000428 15.4999705,5.50000428 Z"
      />
    </svg>
  );
}

export default BackArrowIcon;
